import { Card } from 'antd'
import React from 'react'
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

const  statusCounts =[
   {new: 236}, 
    {closed: 348},
    {unassigned: 236},
    {pending: 236},
    {individual: 32},
    {group: 59},
  ];
const CustomYAxis = ({ tickSize = 5, stroke = "#8884d8", ...props }) => (
    <YAxis tickSize={tickSize} stroke={stroke} {...props} />
  );
  
const CurrentTicketStatus = () => {
  return (
    <Card title="Current Tickets Status" className="chart-full">
              <ResponsiveContainer width="100%" height={300}>
              <BarChart
                    data={statusCounts.map((item) => {
                        const key = Object.keys(item)[0]; // Extract the key (e.g. 'new', 'closed', etc.)
                        return { name: key, value: item[key] }; // Return an object with the key as 'name' and value as 'value'
                    })}
                    >
                  <XAxis dataKey="name" />
                  <CustomYAxis />
                  <Tooltip />
                  <Bar dataKey="value" fill="#00C49F" />
                </BarChart>
              </ResponsiveContainer>
            </Card>
  )
}

export default CurrentTicketStatus